/* ==========================================================================
   GLANTEX - Slider featured-collection-v2

   Herausgeloest aus dem {% javascript %}-Block von
   sections/featured-collection.liquid.

   GRUND: Shopify gibt den Inhalt eines {% javascript %}-Blocks nur auf den
   Seiten aus, auf denen die zugehoerige Section tatsaechlich gerendert
   wird. Das Stylesheet wird global gebuendelt, das Javascript nicht. Der
   Slider laeuft aber seit der Wiederverwendung auf der Produktseite auch
   ausserhalb seiner Section (snippets/glantex-produkt-slider.liquid) -
   dort blieb er ohne dieses Skript ohne Drag-Gestik und vor allem ohne
   Warenkorb-Anbindung, weil der Knopf bewusst type="button" ist.

   Die Logik ist unveraendert uebernommen; einzige Ergaenzung ist die
   Mehrfachlade-Sperre unten. Geladen wird die Datei von der Section
   selbst und vom Produktseiten-Snippet - eine Quelle, zwei Aufrufer,
   keine zweite Fassung, die auseinanderlaufen koennte.

   Initialisiert wird ueber die Klasse .featured-collection-v2, nicht
   ueber die Section - deshalb greift dasselbe Skript an beiden Orten.
   ========================================================================== */

  (function () {
    // Mehrfachlade-Sperre: Auf der Startseite kann die Section mehrfach
    // vorkommen, und die Produktseite laedt dieselbe Datei aus dem
    // Snippet. Der Browser fuehrt jede Einbindung erneut aus - ohne
    // diese Sperre haengen sonst mehrere shopify:section:load-Zuhoerer
    // und mehrere Warenkorb-Bindungen an denselben Knoepfen.
    if (window.__fcv2Geladen) {
      return;
    }
    window.__fcv2Geladen = true;

    function initSlider(root) {
      if (root.dataset.fcv2Init === 'true') {
        return;
      }
      root.dataset.fcv2Init = 'true';

      var track = root.querySelector('[data-fcv2-track]');
      if (!track) {
        return;
      }

      // Trackpad/Touch-Scrolling funktioniert bereits nativ ueber
      // overflow-x: auto. Hier zusaetzlich Klick-und-Ziehen mit der
      // Maus nachruesten (Desktop hat sonst keine Drag-Gestik).
      //
      // Wichtig: natives Browser-Drag-and-Drop von Bildern/Links im
      // Slider muss zuerst vollstaendig unterbunden werden, sonst
      // uebernimmt der Browser die Geste fuer sein eigenes Bild-/
      // Link-Dragging und die Maus-Events unten kommen nie sauber an.
      track.addEventListener('dragstart', function (e) {
        e.preventDefault();
      });

      // Pointer Events statt einzelner Maus-Events fuer den Slide-Drag.
      //
      // ROOT CAUSE des Klick-/Warenkorb-Bugs: setPointerCapture auf
      // einem Vorfahren-Element (track) leitet waehrend aktiver
      // Capture nicht nur die Pointer-Events, sondern auch die daraus
      // abgeleiteten Maus-Kompatibilitaets-Events - insbesondere
      // click - auf das erfassende Element (track) um, STATT auf das
      // Element, ueber dem der Zeiger tatsaechlich losgelassen wurde.
      // Bisher wurde die Capture schon bei jedem pointerdown gesetzt,
      // also auch bei einem reinen Klick ohne jede Bewegung - der
      // Browser sah dadurch bei JEDEM Klick auf den Produktlink <a>
      // oder den Warenkorb-Button ein click-Ereignis mit Ziel track
      // statt mit Ziel <a>/<button>. track ist aber ein Vorfahre und
      // kein Nachfahre dieser Elemente, daher erkannte der Browser
      // weder eine Link-Aktivierung noch ein Formular-Submit - jeder
      // normale Klick lief komplett ins Leere.
      //
      // Fix: Pointer Capture erst setzen, wenn der Zeiger tatsaechlich
      // ueber den Drag-Schwellwert hinaus bewegt wurde. Ein reiner
      // Klick ohne nennenswerte Bewegung loest daher nie eine
      // Capture/Umleitung aus - click bleibt auf dem echten Ziel,
      // Link-Navigation und Formular-Submit funktionieren wieder wie
      // vom Browser vorgesehen.
      var DRAG_THRESHOLD = 6;

      var isPointerDown = false;
      var isDragging = false;
      var didDrag = false;
      var activePointerId = null;
      var startX = 0;
      var startScrollLeft = 0;
      var pendingScrollLeft = null;
      var rafId = null;

      function getStep() {
        var card = track.querySelector('.featured-collection-v2__card');
        if (!card) {
          return track.clientWidth;
        }
        var style = window.getComputedStyle(track);
        var gap = parseFloat(style.columnGap || style.gap || '0') || 0;
        return card.getBoundingClientRect().width + gap;
      }

      function applyScroll() {
        rafId = null;
        if (pendingScrollLeft !== null) {
          track.scrollLeft = pendingScrollLeft;
          pendingScrollLeft = null;
        }
      }

      track.addEventListener('pointerdown', function (e) {
        // Nur echte Maus-Interaktion uebernehmen - Touch/Pen laufen
        // weiterhin ueber natives Scrollen mit eigenem Scroll-Snap.
        if (e.pointerType !== 'mouse' || e.button !== 0) {
          return;
        }
        // Warenkorb-/Ausverkauft-Button loest nie einen Slider-Drag
        // aus - ein Druck dort bleibt ausschliesslich ein Klick auf
        // den Button, unabhaengig von jeder Mausbewegung danach.
        if (e.target.closest('.featured-collection-v2__form, .featured-collection-v2__button')) {
          return;
        }
        isPointerDown = true;
        isDragging = false;
        didDrag = false;
        activePointerId = e.pointerId;
        startX = e.clientX;
        startScrollLeft = track.scrollLeft;
      });

      track.addEventListener('pointermove', function (e) {
        if (!isPointerDown || e.pointerId !== activePointerId) {
          return;
        }
        var deltaX = e.clientX - startX;

        if (!isDragging) {
          if (Math.abs(deltaX) < DRAG_THRESHOLD) {
            // Noch kein Drag - nichts abfangen, ein anschliessender
            // Klick soll normal funktionieren.
            return;
          }
          // Schwellwert ueberschritten: jetzt erst als Drag behandeln
          // und Pointer Capture aktivieren.
          isDragging = true;
          didDrag = true;
          track.classList.add('is-dragging');
          track.setPointerCapture(activePointerId);
        }

        e.preventDefault();
        // Direkte 1:1-Zuweisung bezogen auf die gesamte Bewegung seit
        // pointerdown (nicht nur seit Ueberschreiten des
        // Schwellwerts), per rAF gebuendelt, damit bei sehr schnellen
        // Mausbewegungen nicht mehrfach pro Frame layoutet wird -
        // keine zusaetzliche Verzoegerung, da noch im selben Frame
        // angewendet.
        pendingScrollLeft = startScrollLeft - deltaX;
        if (rafId === null) {
          rafId = window.requestAnimationFrame(applyScroll);
        }
      });

      function endDrag(e) {
        if (!isPointerDown) {
          return;
        }
        isPointerDown = false;
        var wasDragging = isDragging;
        isDragging = false;
        track.classList.remove('is-dragging');

        if (rafId !== null) {
          window.cancelAnimationFrame(rafId);
          applyScroll();
        }

        if (e && activePointerId !== null && track.hasPointerCapture(activePointerId)) {
          track.releasePointerCapture(activePointerId);
        }
        activePointerId = null;

        if (!wasDragging) {
          // Reiner Klick (kein Drag) - Kartenraster-Snap ist hier
          // nicht noetig, der Browser behandelt den Klick normal.
          return;
        }

        // Kartenraster: nach dem Loslassen einmal aktiv auf die
        // naechstgelegene Karte einrasten (Desktop hat waehrend des
        // Ziehens bewusst kein CSS-Scroll-Snap, siehe oben).
        var step = getStep();
        if (step) {
          var maxScrollLeft = Math.max(0, track.scrollWidth - track.clientWidth);
          var index = Math.round(track.scrollLeft / step);
          var maxIndex = Math.round(maxScrollLeft / step);
          index = Math.max(0, Math.min(index, maxIndex));
          track.scrollTo({ left: index * step, behavior: 'smooth' });
        }
      }

      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);

      // Nach einem echten Ziehen soll der anschliessende Klick auf
      // Produktlink/Warenkorb-Button nicht ausgeloest werden.
      track.addEventListener('click', function (e) {
        if (didDrag) {
          e.preventDefault();
          e.stopPropagation();
          didDrag = false;
        }
      });

      track.addEventListener('wheel', function (e) {
        if (!e.shiftKey || e.deltaY === 0) {
          return;
        }
        e.preventDefault();
        track.scrollLeft += e.deltaY;
      }, { passive: false });
    }

    // Add-to-Cart ist bewusst komplett von initSlider getrennt: eigene
    // Funktion, eigene Klick-Listener direkt am Button, keine
    // gemeinsamen Variablen oder Event-Listener mit dem Slider oben.
    // Die Slider-Pointer-Logik (pointerdown/pointermove/pointerup/
    // pointercancel, Drag-Schwellwert, scrollLeft, dragstart-Sperre)
    // wird hier weder gelesen noch veraendert.
    function initForms(root) {
      var forms = root.querySelectorAll('[data-fcv2-form]');
      forms.forEach(function (form) {
        if (form.dataset.fcv2FormInit === 'true') {
          return;
        }
        form.dataset.fcv2FormInit = 'true';

        var button = form.querySelector('[data-fcv2-add-to-cart]');
        var idInput = form.querySelector('input[name="id"]');
        if (!button || !idInput) {
          return;
        }

        var isSubmitting = false;

        // Klick-Handler direkt am Button statt (nur) am submit-Event
        // des Formulars: preventDefault laeuft hier synchron als
        // allererste Zeile bei jedem Klick, unabhaengig davon, ob und
        // wann andere Skripte bereits geladen bzw. gebunden haben. In
        // Kombination mit button type=button auf diesem Element (siehe
        // Markup oben) kann die native Formular-Aktion des Warenkorb-
        // Formulars unter keinen Umstaenden mehr ausgeloest werden -
        // das war die Ursache des bisherigen Redirects auf die
        // Warenkorbseite: das Formular postete nativ gegen den
        // Nicht-JSON Add-Endpoint, den Shopify standardmaessig per
        // Redirect auf die Warenkorbseite beantwortet.
        //
        // Add-to-Cart laeuft stattdessen ueber die Shopify AJAX Cart
        // API (JSON-Endpoint unter Shopify.routes.root, locale-aware).
        // Fuer das Rendern und Oeffnen des Warenkorbs wird nichts Neues
        // gebaut, sondern exakt die bestehende Theme-Logik aus
        // theme.js wiederverwendet: der normale Produktseiten-Add-to-
        // Cart-Handler (theme.AjaxProduct) dispatcht nach Erfolg das
        // Event ajaxProduct:added; der bereits global instanziierte
        // Cart-Drawer-Controller (theme.CartDrawer) hoert exakt darauf
        // und fuehrt dabei beides aus: den Drawer-Inhalt per
        // cartForm.buildCart neu rendern UND den Drawer per open
        // tatsaechlich oeffnen. Ein blosses cart:build wuerde nur den
        // Inhalt neu rendern (das hoert nur der Cart-Form-Controller),
        // aber den Drawer nicht oeffnen - deshalb wird hier bewusst
        // ajaxProduct:added verwendet, das schon beides abdeckt.
        button.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();

          if (isSubmitting || !window.Shopify || !window.Shopify.routes) {
            return;
          }
          isSubmitting = true;
          button.classList.add('btn--loading');

          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              id: idInput.value,
              quantity: 1
            })
          })
            .then(function (response) {
              return response.json().then(function (data) {
                return { ok: response.ok, data: data };
              });
            })
            .then(function (result) {
              isSubmitting = false;
              button.classList.remove('btn--loading');

              if (!result.ok || result.data.status === 422) {
                console.warn(result.data);
                return;
              }

              document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                detail: {
                  product: result.data,
                  addToCartBtn: button
                }
              }));
            })
            .catch(function (error) {
              isSubmitting = false;
              button.classList.remove('btn--loading');
              console.warn(error);
            });
        });
      });
    }

    function initAll() {
      document.querySelectorAll('.featured-collection-v2').forEach(function (root) {
        initSlider(root);
        initForms(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (evt) {
      var root = evt.target.querySelector ? evt.target.querySelector('.featured-collection-v2') : null;
      if (root) {
        initSlider(root);
        initForms(root);
      }
    });
  })();
